<template>
  <div class="News">
    <div v-if="isLargeScreen">
      <news-list></news-list>
    </div>
    <div v-else>
      <news-mobile-list></news-mobile-list>
    </div>
  </div>
	
</template>
<script setup>
import newsList from './list.vue'
import newsMobileList from './listmobile.vue'
import { ref, onMounted, onUnmounted, computed } from 'vue';

// 1. 定义一个响应式变量来存储窗口宽度
const windowWidth = ref(window.innerWidth);

// 2. 定义一个方法来更新窗口宽度
const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

// 3. 使用 computed 属性来判断屏幕大小
//    这里以 768px 为分界线，你可以根据需求修改
const isLargeScreen = computed(() => {
  return windowWidth.value >= 768;
});

// 4. 组件挂载时：添加 resize 事件监听器
onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

// 5. 组件卸载时：移除 resize 事件监听器，防止内存泄漏
onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});
</script>

<style lang="less">
.News{
  
}
</style>